module.exports = __webpack_public_path__ + "img/placeholder.6839d274.jpg";